import { render, staticRenderFns } from "./FollowUp.vue?vue&type=template&id=6b267768&scoped=true"
import script from "./FollowUp.vue?vue&type=script&setup=true&lang=js"
export * from "./FollowUp.vue?vue&type=script&setup=true&lang=js"
import style0 from "./FollowUp.vue?vue&type=style&index=0&id=6b267768&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b267768",
  null
  
)

export default component.exports